/** PC /notification 左侧导航：首页底部公开内容 Tab（非站内信 type） */
export const PUBLIC_FEED_TAB = {
  ANNOUNCEMENT: "feed-announcement",
  NEWS: "feed-news",
  ACADEMY: "feed-academy",
};

export function isPublicFeedTab(navActive) {
  return Object.values(PUBLIC_FEED_TAB).includes(navActive);
}

export const ZENDESK_CATEGORY = {
  ANNOUNCEMENT: "5284067920670-Announcements",
  ACADEMY: "5284051234846-Academy",
};
